export default __webpack_public_path__ + "static/media/image_transmedia.07980318.png";